define([
    'lodash'
], function (_) {
    'use strict';

    function defaultSortFn(a, b) {
        return a.localeCompare(b);
    }

    function sort(src, comparator = defaultSortFn) {
        let out;

        if (Array.isArray(src)) {
            return src.map(item => sort(item, comparator));
        }

        if (_.isPlainObject(src)) {
            out = {};

            Object.keys(src).sort(comparator).forEach(key => {
                out[key] = sort(src[key], comparator);
            });

            return out;
        }

        return src;
    }

    return sort; 
});